module.exports = __webpack_public_path__ + "3690d495d44b9f8de993c8107e5554a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-1024.jpg
// module id = 463
// module chunks = 0